import { render } from "./DeliveryTripModal.vue?vue&type=template&id=51e42572&scoped=true"
import script from "./DeliveryTripModal.vue?vue&type=script&lang=js"
export * from "./DeliveryTripModal.vue?vue&type=script&lang=js"

import "./DeliveryTripModal.vue?vue&type=style&index=0&id=51e42572&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e42572"]])

export default __exports__